import request from '@/api/axios';

export function getDeviceInfoByIccid(iccid) {
	return request({
		url: `/api/device/v1/getDeviceInfoByIccid/${iccid}`,
		method: 'get',
	});
}
